module.exports = "https://static.wmbcdn.com/uniweb/images/34dc403f34cb74e51ae8e5dce1c31d38.svg";